<template>
    <v-fade-transition group origin="center center 0" leave-absolute>
        <modify-login v-show="showLogin" key="login" />
        <modify-form v-show="showForm" key="form" />
    </v-fade-transition>
</template>

<script>
import ModifyLogin from "@/components/client/experts/modify/modify-login.vue";
import ModifyForm from "@/components/client/experts/modify/modify-form.vue";

export default {
    components: { ModifyLogin, ModifyForm },
    computed: {
        accessToken() {
            return !!this.$store.state?.accessToken;
        },
    },
    data() {
        return {
            showLogin: true,
            showForm: false,
        };
    },
    methods: {
        init() {
            if (this.accessToken) {
                this.showLogin = false;
                this.showForm = true;
            } else {
                this.showForm = false;
                this.showLogin = true;
            }
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        accessToken() {
            if (this.accessToken) {
                this.showLogin = false;
                setTimeout(() => (this.showForm = true), 500);
            } else {
                this.showForm = false;
                setTimeout(() => (this.showLogin = true), 500);
            }
        },
    },
};
</script>
